import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-request-delete-modal',
  templateUrl: './request-delete-modal.component.html',
  styleUrls: ['./request-delete-modal.component.css']
})
export class RequestDeleteModalComponent implements OnInit {
  @Input() public request: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
